import React from 'react';
// import MobileStoreButton from 'react-mobile-store-button';
import HeroImage from '../../assets/images/hero-image.svg';
// import useWindowSize from '../../hooks/useWindowSize';
import {
  Navbar
} from '../../components';

const Hero = () => {
  // const  { width } = useWindowSize();
  return (
    <div className="container-fluid bg-link pb-5">
      <Navbar />
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6 col-12">
            <h1 className="text-info">
              <strong>The best in caps, preforms, and bottles.</strong>
            </h1>
            <p className="text-secondary mt-5">
              The leading distributor of caps in Nigeria Innovation Associates has a legacy of core values, which we culture and preserve in our operations and practice because of who we are.    
            </p>
            <div className="mt-5">
              <a href="#contact" className="btn btn-primary rounded-3 px-4 py-3 font-weight-bold">
                Get in touch 
              </a>
            </div>
            {/*
            <div className="d-flex justify-content-left align-items-center mt-5">
              <div className="mr-5">
                  <MobileStoreButton
                    url="https://innovationa.com.ng"
                    store="ios"
                    linkProps={{ title: 'iOS Store Button' }}
                    width={ width < 700 ? 148 : 175 }
                    height={ width < 700 ? 47 : 52 }
                  />
              </div> 
              <div>
                  <MobileStoreButton
                    url="https://innovationa.com.ng"
                    store="android"
                    linkProps={{ title: 'Google Play Button' }}
                    width={ width < 700 ? 173 : 200 }
                    height={ width < 700 ? 72 : 77 }
                  />
              </div> 
            </div>
            */}
          </div>
          <div className="col-md-6 col-12">
            <img
              src={HeroImage} 
              alt="Preforms"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Hero };
